import { useQuery } from '@tanstack/react-query';
import { referralsAPI } from '../api/referrals';

export function useReferralCode() {
  return useQuery({
    queryKey: ['referralCode'],
    queryFn: referralsAPI.getReferralCode,
    staleTime: 1000 * 60 * 60, // 1 hour - referral code doesn't change often
  });
}

export function useReferralStats() {
  return useQuery({
    queryKey: ['referralStats'],
    queryFn: referralsAPI.getReferralStats,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
